/* global I18n */

import React from "react"
import TrackableLink from "./trackable_link"
import Popover from "./popover"

export default (props) => (
  <Popover
    target={props.target}
    on_close={props.on_close}
    is_open={props.is_open}
    placement={props.placement}
    modifiers={props.modifiers}
    title={I18n.t("js.premium_popover.title")}
    content={I18n.t("js.premium_popover.content")}>
    <TrackableLink
      tracking_event="pricing page clicked"
      tracking_element={props.element}
      href={window.gon.pricing_path}
      on_click={props.on_close}>
      {I18n.t("js.premium_popover.cta")}
    </TrackableLink>
  </Popover>
)
